export const TID = {
  nav: {
    logo: "nav-logo",
    contact: "nav-contact-cta",
  },
  hero: {
    root: "hero-section",
    cta: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    slide: (i) => `hero-slide-${i}`,
    dot: (i) => `hero-slide-dot-${i}`,
    prev: "hero-slide-prev",
    next: "hero-slide-next",
    caption: "hero-slide-caption",
  },
  gallery: {
    root: "gallery-section",
    filter: (cat) => `gallery-filter-${cat.toLowerCase()}`,
    card: (idx) => `gallery-card-${idx}`,
    empty: "gallery-empty-state",
  },
  modal: {
    root: "lightbox-modal",
    close: "modal-close-btn",
    prev: "modal-prev-btn",
    next: "modal-next-btn",
    title: "modal-title",
  },
  contact: {
    root: "contact-section",
    name: "contact-input-name",
    email: "contact-input-email",
    company: "contact-input-company",
    projectType: "contact-select-project-type",
    message: "contact-textarea-message",
    submit: "contact-submit-btn",
    success: "contact-success-state",
    mailto: "contact-mailto-link",
  },
};
